<template>
  <transition name="page">
    <div class="page-module" @click="closeModule">
      <div class="radio-popup" @click.stop="">
        <div class="popup-head" v-html="title"></div>
          <radio-item v-bind="{
            options: optionsClone,
            edit,
            valKey,
            remove,
            editSwitch,
            delSwitch,
            addItemSwitch,
            addItemCallBack,
            radioSelect
          }"></radio-item>
        <div class="popup-btns">
          <button
            v-for="item in btnConf"
            @click="item.callBack()"
            v-text="item.text"
            :class="{'sole': btnConf.length === 1}"
            class="btn fl"
          ></button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import Vue from 'vue';
  import radioItem from './radio_item';

  export default {
    name: "radio_popup",
    components: {
       'radio-item':  radioItem
    },
    props: {
      btnText: {},
      _switch: Boolean,
      title: String,
      options: {
        default: function () {
          return ['没有数据']
        }
      },
      valKey: {
        default: 'tname'
      },
      radioConf: null,
      edit: Function,
      remove: Function,
      radioSelect: Function,
      editSwitch:  {
        type: Boolean,
        default: false
      },
      btnLock: {
        type: Boolean,
        default: true
      },
      delSwitch: {
        type: Boolean,
        default: false
      },
      addItemSwitch: {
        type: Boolean,
        default: false
      },
      addItemCallBack: Function,
      btnConf: Array
    },
    data() {
      return {
        radioSelectItem: null,
        optionsClone: this.initOptions()
      }
    },
    watch: {
      options: function() {
        this.optionsClone = this.initOptions();
      }
    },
    methods: {
      closeModule() {
        this.$emit('close');
      },
      initOptions() {
        return [].concat(JSON.parse(JSON.stringify(this.options)));
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/radio_popup.css";
</style>



// WEBPACK FOOTER //
// src/components/radio_popup.vue